import Input from 'components/molecules/Input';

interface BroadcastTemplateConfigProps {
  template?: any;
  handleChange: (data: any) => void;
  handleForm: (data: any) => void;
}

function BroadcastTemplateConfig({ template, handleChange, handleForm }: BroadcastTemplateConfigProps) {
  return (
    <Input
      label="Message"
      isMultiLine
      rows={6}
      className="mb-4"
      value={template?.config?.message}
      onChangeText={(t) => {
        handleChange((prevState) => {
          return { ...prevState, config: { ...prevState.config, message: t } };
        });
        handleForm((prevState) => {
          return { ...prevState, config: { ...prevState.config, message: t } };
        });
      }}
      required
    />
  );
}

export default BroadcastTemplateConfig;
